import type { InputSlot } from '@/types/image-template';
import type { CanvasTemplateSlotValue } from '@/types/visual-editor';

export const STORYBOARD_REPLICA_PROMPT_SLOT_KEY = 'reference_storyboard_prompt';
export const PRODUCT_STORYBOARD_VIDEO_PROMPT_BUILDER = 'product_storyboard_video_delivery';
export const MODEL_STORYBOARD_VIDEO_PROMPT_BUILDER = 'model_storyboard_video_delivery';

const PROMPT_TEXT_SLOT_EXACT_KEYS = new Set([
  STORYBOARD_REPLICA_PROMPT_SLOT_KEY,
  'brief',
  'creative_note',
  'brand_note',
  'styling_note',
  'instruction',
  'instructions',
]);

const PROMPT_TEXT_SLOT_KEYWORDS = [
  'prompt',
  'storyboard',
  'script',
  'brief',
  'creative note',
  'brand note',
  'styling note',
  'instruction',
  'direction',
  'campaign mood',
  'motion rhythm',
  'editorial direction',
  'ad mood',
  'brand tone',
  '提示词',
  '分镜',
  '脚本',
  '剧本',
  '复刻',
  '创意',
  '补充',
  '说明',
  '镜头',
  '节奏',
  '方向',
  '气质',
  '调性',
];

function normalizeText(value: unknown): string {
  return typeof value === 'string' ? value.trim().toLowerCase() : '';
}

export function getTemplatePromptBuilderFromModelParams(modelParams: Record<string, unknown> | undefined): string {
  const raw = modelParams?.prompt_builder;
  return normalizeText(raw);
}

function buildTemplateTextSlotSearchCorpus(slot: InputSlot): string {
  return [
    slot.key,
    slot.label,
    slot.label_zh,
    slot.hint,
    slot.hint_zh,
    slot.default_value,
  ]
    .map(normalizeText)
    .filter((part) => part.length > 0)
    .join(' ');
}

export function isPromptLikeTemplateTextSlot(slot: InputSlot): boolean {
  if (slot.type !== 'text') {
    return false;
  }

  const normalizedSlotKey = normalizeText(slot.key);
  if (PROMPT_TEXT_SLOT_EXACT_KEYS.has(normalizedSlotKey)) {
    return true;
  }

  const searchableText = buildTemplateTextSlotSearchCorpus(slot);
  return PROMPT_TEXT_SLOT_KEYWORDS.some((keyword) => searchableText.includes(keyword));
}

export function getTemplateTextSlotSourceNodeId(slotValue: CanvasTemplateSlotValue | undefined): string {
  return typeof slotValue?.sourceNodeId === 'string' ? slotValue.sourceNodeId.trim() : '';
}

export function shouldMaterializeTemplateTextSlotPrompt(
  slot: InputSlot,
  slotValue: CanvasTemplateSlotValue | undefined,
): boolean {
  if (slot.type !== 'text') {
    return false;
  }

  if (!isPromptLikeTemplateTextSlot(slot)) {
    return false;
  }

  return normalizeText(slotValue?.text).length > 0;
}